import React from 'react';
import s from './PublishInstructions.module.scss';

const PublishInstructionsText = () => (
    <React.Fragment>
        <div className={s.instructionsTitle}>Instructions</div>
        <div className={s.instructionsText}>
            The publish process takes your saved changes in the Wayfinder Venue Management System and promotes it to Wayfinder. A few things to note:
            <ul>
                <li>
                    Publishing is a pipeline that packages your updates with the wayfinding, search, map and POI data for the venue. This process can take from 5 to 30 minutes depending on the size of
                    the venue.
                </li>
                <li>Once the publish process is pending, all users for that venue must wait until the process completes before publishing again.</li>
                <li>If there is an error, the Atrius content team is automatically notified and will resolve any errors for you. You cannot make any new publishes until the errors are resolved.</li>
                <li>If you have any questions, click the Help button.</li>
            </ul>
        </div>
    </React.Fragment>
);

export default PublishInstructionsText;
